import { render } from "./HotspotSpecial.vue?vue&type=template&id=4713f3b4&scoped=true&ts=true"
import script from "./HotspotSpecial.vue?vue&type=script&lang=ts"
export * from "./HotspotSpecial.vue?vue&type=script&lang=ts"

import "./HotspotSpecial.vue?vue&type=style&index=0&id=4713f3b4&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4713f3b4"]])

export default __exports__